import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class SendButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {returnOrder, detail, agency, dealer} = this.props;

    if (!detail.length) {
      this.props.addMessageBoxWarning('No se puede enviar órdenes de devolución vacías.');
      return;
    }

    if (returnOrder) {
      this.props.processPartsReturnOrder(returnOrder.code, detail, 'send');
      return;
    }

    this.props.createPartsReturnOrder({dealer, agency, detail, 'sendOrder': true});
  }

  render() {
    const {returnOrder, processing, deleting} = this.props;

    if (!returnOrder || (returnOrder && returnOrder.status !== 'I')) {
      return null;
    }

    return (
      <Button primary content='ENVIAR' disabled={processing || deleting} onClick={this.handleClick} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'userDealer': state.session.dealerId,
    'userAgency': state.session.dealerAgency,
    'detail': state.partsReturnsOrders.orderDetail,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
    'processing': state.partsReturnsOrders.processing,
    'deleting': state.partsReturnsOrders.deleting,
  };
};

const {
  createPartsReturnOrder,
  processPartsReturnOrder,
  addMessageBoxWarning,
} = Actions;

export default connect(mapStateToProps, {
  createPartsReturnOrder,
  processPartsReturnOrder,
  addMessageBoxWarning,
})(SendButton);
